export default "__VITE_ASSET__892bed97__"